export const DocumentText = ({
  className,
  strokeColor = 'currentColor',
}: {
  className?: string
  strokeColor?: string
}) => (
  <svg
    className={className}
    fill='none'
    height='13'
    viewBox='0 0 16 13'
    width='16'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2.80078 2.30078H11.2008V12.5008H2.80078V2.30078Z'
      fill='none'
      stroke={strokeColor}
      strokeLinejoin='round'
    />
    <path
      d='M9.4 2.3V0.5H1.3C1.22044 0.5 1.14413 0.531607 1.08787 0.587868C1.03161 0.644129 1 0.720435 1 0.8V10.7H2.8M5.2 5.9H8.8M5.2 8.3H8.8'
      fill='none'
      stroke={strokeColor}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
